import { AppSettings } from '../../app.settings';
import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { PayrollAdminLandingService } from '../../services/payroll-admin-landing/payroll-admin-landing.service';

@Injectable({
  providedIn: 'root',
})
export class PayrollHomeRedirectGuard {
  constructor(
    private payrollAdminLandingService: PayrollAdminLandingService,
    private router: Router,
  ) {}

  async canActivate(): Promise<UrlTree> {
    const nextRoute = await this.payrollAdminLandingService.getLandingRoute();

    const target = this.router.parseUrl(nextRoute);
    target.queryParams = {...target.queryParams, ...AppSettings.getLocalNavigationQueryParams()};
    return target;
  }
}
